import React, { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Text, ConfirmButton, StyledSelect } from 'components';
import SearchBar from 'components/SearchBar';
import Table from 'components/Table/userTable';
import mockUsers from 'components/Table/mockdata/users.json';
import { motion } from 'framer-motion';
import { normalizeText } from 'utils/formatting';
import User from 'typings/User';
import SelectFilter from 'components/SelectFilter';
import Input from './Input';
import {
  BottomContainer,
  ButtonContainer,
  Container,
  Filters,
  Form,
  LoginFormContainer,
  LogoContainer,
} from './styles';

const Users: React.FC = () => {
  const [searchValue, setSearchValue] = useState('');
  const [filterValues, setFilterValues] = useState([] as { value: string; type: string; }[]);

  const { t } = useTranslation();

  const roles = [
    { value: '0', label: `${t('userRole_ADMIN')}` },
    { value: '1', label: `${t('userRole_MANAGER')}` },
    { value: '2', label: `${t('userRole_VIEWER')}` },
  ];

  const pageVariants = {
    initial: {
      opacity: 0,
    },
    in: {
      opacity: 1,
    },
    out: {
      opacity: 0,
    },
  };
  const pageTransition = {
    type: 'tween',
    ease: 'anticipate',
    duration: 0.5,
  };

  const filteredData = useCallback(() => {

    let users: User[] = mockUsers;

    if (searchValue) {
      const normalizedSearch = normalizeText(searchValue);
      const deviceFields = ['device', 'owner', 'status'];
      users = mockUsers.filter((device: Record<string, string>) =>
        deviceFields.some(field =>
          normalizeText(device[field]).includes(normalizedSearch),
        ),
      );
    }

    if (filterValues.length) {
      users = users.filter(d => {
        return filterValues.some(({ type, value }) => {
          return d[type] === value
        });
      });
    }

    return users;

  }, [searchValue, filterValues]);

  const options = [
    {
      type: "role",
      options: [
        { value: '0', label: `${t('userRole_ADMIN')}`, type: "role" },
        { value: '1', label: `${t('userRole_MANAGER')}`, type: "role" },
        { value: '2', label: `${t('userRole_VIEWER')}`, type: "role" },
      ]
    }
  ];

  return (
    <Container>
      <div className="Users" />
      <motion.div
        initial="initial"
        animate="in"
        exit="out"
        variants={pageVariants}
        transition={pageTransition}
      >
        <div>
          <BottomContainer>
            <LoginFormContainer>
              <Text noSelect fontFamily="Nunito Bold" fontSize="32px">
                {t('Users')}
              </Text>
              <Form onSubmit={() => ''}>
                <Input
                  name="nome"
                  placeholder={t('login:name')}
                  onSubmit={() => ''}
                />
                <Input
                  name="email"
                  placeholder={t('login:email')}
                  onSubmit={() => ''}
                />
                <Input
                  name="password"
                  placeholder={t('login:password')}
                  onSubmit={() => ''}
                />
                <StyledSelect options={roles} />
                <ButtonContainer>
                  <ConfirmButton
                    fontSize="24px"
                    height="61px"
                    width="120px"
                    onClick={() => ''}
                    debounce={200}
                    shadow
                  />
                </ButtonContainer>
              </Form>
            </LoginFormContainer>
            <LogoContainer className="no-user-select">
              <div>
                <SearchBar onSearch={setSearchValue} top="140px" left="750px" />
                <Filters>
                  <SelectFilter placeholder={`${t('RoleType')}`} options={options} onChange={opts => {
                    setFilterValues(opts);
                  }} />
                </Filters>
              </div>
              <div>
                <Table data={filteredData()} />
              </div>
            </LogoContainer>
          </BottomContainer>
        </div>
      </motion.div>
    </Container>
  );
};

export default Users;
